import { useEffect, useState } from "react";
import {
  Modal,
  Content,
  IconCircle,
  TrashIcon,
  Title,
  Body,
  ConfirmHelp,
  ConfirmInput,
  ConfirmButton,
  CancelButton,
} from "./delete-event-dialog.styles";

const CONFIRM_PHRASE = "DELETE";

export type DeleteEventDialogProps = {
  open: boolean;
  eventName: string;
  deleting?: boolean;
  onCancel: () => void;
  onConfirm: () => void;
};

const DeleteEventDialog = ({
  open,
  eventName,
  deleting = false,
  onCancel,
  onConfirm,
}: DeleteEventDialogProps) => {
  const [confirmText, setConfirmText] = useState("");

  useEffect(() => {
    if (!open) setConfirmText("");
  }, [open]);

  const canConfirm = confirmText.trim().toUpperCase() === CONFIRM_PHRASE;

  return (
    <Modal
      open={open}
      onClose={deleting ? undefined : onCancel}
      data-testid="delete-event-dialog"
    >
      <Content>
        <IconCircle>
          <TrashIcon />
        </IconCircle>
        <Title>Delete this event?</Title>
        <Body>
          You're about to permanently delete <strong>{eventName || "this event"}</strong>.
          All rounds, tasters, and results will be lost forever.
        </Body>
        <ConfirmHelp>
          Type <strong>DELETE</strong> below to confirm.
        </ConfirmHelp>
        <ConfirmInput
          value={confirmText}
          onChange={(e: any) => setConfirmText(e.target.value)}
          disabled={deleting}
        />
        <ConfirmButton
          variant="contained"
          disabled={!canConfirm || deleting}
          onClick={onConfirm}
          data-testid="delete-event-confirm"
          startIcon={<TrashIcon />}
        >
          {deleting ? "Deleting..." : "Delete Event"}
        </ConfirmButton>
        <CancelButton onClick={onCancel} disabled={deleting}>
          Cancel
        </CancelButton>
      </Content>
    </Modal>
  );
};

export default DeleteEventDialog;
